import { createSelector } from '@reduxjs/toolkit';
import { name } from './constants';
var selectApplicationState = function (state) { return state[name]; };
var selectApplicationOnlineStatus = createSelector(selectApplicationState, function (applicationState) {
    return applicationState.online;
});
export { selectApplicationOnlineStatus };
